export default __webpack_public_path__ + "static/media/jobs_icon.03fb4031.svg";